import { useState, useRef, useEffect } from "react";
import { Toast } from "primereact/toast";
import { IconField } from "primereact/iconfield";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
// import ModalAddClassifications from "./ModalAddMaterials";
import ModalAddMaterials from "./ModalAddMaterials";
import {
    getDataAll,
    deleteMaterial,
    setDataNull,
} from "../../store/materials/slice";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Paginator } from "primereact/paginator";
import ActionMenu2 from "../../components/ActionMenu2";
import ModelDelete from "../../components/ModalDelete";
import { formatNumber, formatQuantity } from "../../components/utils";
import { formatDate } from "../Plan/ModalShowPlan";
import { MultiSelect } from "primereact/multiselect";
import { getDataAll as getDataAllClassification } from "../../store/classifications/slice";
import { Dropdown } from "primereact/dropdown";
import { Menu } from "primereact/menu";
import ModalImportExcel from "./ModalImportExcel";
import { exportExcel, clearDataExcel } from "../../store/Excels/slice";
import { site } from "../../api/url_helper";
import { deleteManyRequest } from "../../store/processings/slice";
import { Calendar } from "primereact/calendar";
import { getBuilding } from "../../store/order/slice";

export default function Materials() {
    const toast = useRef(null);
    const menuRight = useRef(null);
    const dispatch = useDispatch();
    const [keyword, setKeyword] = useState("");
    const [dialogAddVisible, setDialogAddVisible] = useState(false);
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);
    const [rowData, setRowData] = useState();
    const [modalDelete, setModalDelete] = useState(false);
    const [orderCodeValue, setOrderCodeValue] = useState("");
    const [factoryCodeValue, setFactoryCodeValue] = useState("");
    const [selectedClassification, setSelectedClassification] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [type, setType] = useState(null);
    const [visibleImportExcel, setVisibleImportExcel] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [startDate, setStartDate] = useState(new Date("2024-08-01"));
    const [endDate, setEndDate] = useState(new Date());
    const [buildingOptions, setBuildingOptions] = useState([]);
    const [building, setBuilding] = useState(null);
    const [buildingValue, setBuildingValue] = useState();

    const {
        loading,
        materialData,
        insertData,
        deleteData,
        updateData,
        classificationData,
        exportExcelData,
        exportError,
        deleteMany,
        dataBuilding,
    } = useSelector(
        (state) => ({
            loading: state.Materials.loading,
            materialData: state.Materials.materialData,
            insertData: state.Materials.insertData,
            deleteData: state.Materials.deleteData,
            updateData: state.Materials.updateData,
            classificationData: state.Classifications.classificationData,
            exportExcelData: state.Excel.exportExcelData.data,
            exportError: state.Excel.exportExcelData.error,
            deleteMany: state.Processings.deleteMany,
            dataBuilding: state.Production.dataBuilding,
        }),
        shallowEqual
    );
    useEffect(() => {
        if (deleteMany) {
            toast.current?.show({
                severity: "success",
                summary: "Thành công",
                detail: "Xoá thành công",
                life: 3000,
            });
        }
        dispatch(setDataNull());
    }, [deleteMany]);
    const showToast = (severity, summary, detail) => {
        toast.current?.show({ severity, summary, detail, life: 3000 });
    };
    useEffect(() => {
        if (exportExcelData) {
            const file = exportExcelData?.data;
            console.log("exportExcelData", exportExcelData);

            const fileUrl = `${site}/${file}`;
            const link = document.createElement("a");
            link.href = fileUrl;
            link.setAttribute("download", "Sample data.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            dispatch(clearDataExcel());
            showToast("success", "Thành công", "Tải thành công");
        } else if (exportError) {
            showToast(
                "error",
                "Thất bại",
                exportError?.response?.data?.message
            );
        }
    }, [exportExcelData, exportError]);
    function formatDateToYYYYMMDD(dateString) {
        const date = new Date(dateString);
        if (isNaN(date)) {
            return "Invalid Date";
        }

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Tháng bắt đầu từ 0
        const day = String(date.getDate()).padStart(2, "0");

        return `${year}/${month}/${day}`;
    }

    useEffect(() => {
        const timeout = setTimeout(() => {
            dispatch(
                getDataAll({
                    page: (first + rows) / rows,
                    limit: rows,
                    keyword: keyword,
                    type,
                    factoryCode: factoryCodeValue,
                    orderCode: orderCodeValue,
                    classificationIds: JSON.stringify(selectedClassification),
                    filterStatus: JSON.stringify(selectedStatus),
                    timeStartReq: formatDateToYYYYMMDD(startDate),
                    timeEndReq: formatDateToYYYYMMDD(endDate),
                    building,
                })
            );
        }, 300);

        return () => clearTimeout(timeout);
    }, [
        rows,
        first,
        keyword,
        insertData,
        deleteData,
        updateData,
        type,
        orderCodeValue,
        factoryCodeValue,
        selectedClassification,
        deleteMany,
        selectedStatus,
        startDate,
        endDate,
        building,
    ]);

    useEffect(() => {
        dispatch(getDataAllClassification({ page: 1, limit: 100 }));
    }, []);

    useEffect(() => {
        if (deleteData) {
            toast.current?.show({
                severity: "success",
                summary: "Thành công",
                detail: "Xoá vật tư thành công",
                life: 3000,
            });
        }
        dispatch(setDataNull());
    }, [deleteData]);

    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
    };

    const handleEdit = (rowData) => {
        setRowData(rowData);
        setDialogAddVisible(true);
    };

    const handleDelete = (rowData) => {
        setModalDelete(true);
        setRowData(rowData);
    };
    const actionBodyTemplate = (rowData) => {
        return (
            <ActionMenu2
                onEdit={() => handleEdit(rowData)}
                onDelete={() => handleDelete(rowData)}
            />
        );
    };
    const acceptDelete = () => {
        if (rowData) {
            const id = rowData.id;

            if (id !== undefined) {
                dispatch(deleteMaterial({ id }));
            }
            setModalDelete(false);
        }
    };
    const logDataTable = () => {
        dispatch(
            exportExcel({
                type: "material",
            })
        );
    };
    const handleClick = (event) => {
        menuRight.current.show(event);
    };
    const items = [
        {
            label: "Nhập từ excel",
            icon: "pi pi-file-excel",
            command: () => setVisibleImportExcel(true),
        },
        {
            label: "Xuất ra excel",
            icon: "pi pi-file-excel",
            command: logDataTable,
        },
    ];
    const handleSelectionChange = (e) => {
        const selected = e.value || [];
        const currentPageItems = classificationData?.data?.items || [];

        // Loại bỏ các phần tử thuộc trang hiện tại khỏi selectedProducts
        const filteredProducts =
            selectedProducts?.filter(
                (item) => !currentPageItems.some((row) => row.id === item.id)
            ) || [];

        // Gộp các phần tử không bị xóa với phần tử vừa chọn
        const updatedSelection = [...filteredProducts, ...selected];

        // Loại bỏ phần tử trùng lặp
        const uniqueSelection = Array.from(
            new Map(updatedSelection.map((item) => [item.id, item])).values()
        );

        setSelectedProducts(uniqueSelection);
    };

    const handleDeleteMany = () => {
        if (selectedProducts?.length > 0) {
            dispatch(
                deleteManyRequest({
                    type: "material",
                    ids: selectedProducts?.map((item) => item.id),
                })
            );

            setSelectedProducts([]);
        }
    };
    useEffect(() => {
        dispatch(
            getBuilding({
                page: 1,
                limit: 100,
            })
        );
    }, [dispatch]);
    const removeDuplicates = (array, key) => {
        return array.filter(
            (item, index, self) =>
                index === self.findIndex((t) => t[key] === item[key])
        );
    };
    useEffect(() => {
        if (dataBuilding?.data?.items) {
            const buildings = dataBuilding.data.items.map((item) => ({
                label: item.name,
                value: item.id,
            }));
            setBuildingOptions(removeDuplicates(buildings, "value"));
        }
    }, [dataBuilding]);
    const handleBuildingChange = (e) => {
        setBuilding(e.target.value);
        setBuildingValue(e.target.value);
    };
    return (
        <div className="flex flex-column h-full">
            <Toast ref={toast} />
            <div className="pb-3 flex gap-8">
                <div className="flex gap-4 w-full">
                    <Button
                        label="Thêm vật tư"
                        style={{ height: "35px", width: "200px" }}
                        onClick={() => setDialogAddVisible(true)}
                    />
                    <div className="flex gap-3 max-w-max h-2rem w-12 md:h-auto">
                        <div className="calendar-container">
                            <label htmlFor="startDate">Từ ngày:</label>
                            <Calendar
                                locale="vi"
                                id="startDate"
                                value={startDate}
                                onChange={(e) => {
                                    setStartDate(e.target.value);
                                }}
                                dateFormat="dd/mm/yy"
                                className="calendar-custom"
                                style={{ height: "35px" }}
                            />
                        </div>
                        <div className="calendar-container">
                            <label htmlFor="endtDate">Đến ngày:</label>
                            <Calendar
                                locale="vi"
                                id="endDate"
                                value={endDate}
                                onChange={(e) => {
                                    setEndDate(e.target.value);
                                }}
                                dateFormat="dd/mm/yy"
                                className="calendar-custom"
                                minDate={startDate}
                            />
                        </div>
                    </div>
                    <IconField className="w-full">
                        <InputText
                            value={keyword}
                            onChange={(e) => setKeyword(e.target.value)}
                            placeholder="Tìm kiếm"
                            className="w-full border-0"
                        />
                    </IconField>
                </div>
                <div className="flex gap-4">
                    {selectedProducts?.length > 0 && (
                        <Button
                            label="Xóa"
                            style={{ height: "35px" }}
                            onClick={() => handleDeleteMany()}
                        />
                    )}
                    <Button
                        label={"Thao tác"}
                        popup="true"
                        icon={"pi pi-sort-down-fill"}
                        onClick={handleClick}
                        aria-controls="popup_menu_right"
                        aria-haspopup
                        iconPos="right"
                        style={{ width: "200px", height: "35px" }}
                    />
                </div>
                <Menu
                    model={items}
                    popup="true"
                    ref={menuRight}
                    id="popup_menu_right"
                    popupAlignment="right"
                    style={{ minWidth: "200px" }}
                />
            </div>
            <div className="flex gap-4 pb-3">
                <IconField className="search-item">
                    <MultiSelect
                        placeholder="Lọc công trình"
                        options={buildingOptions}
                        onChange={handleBuildingChange}
                        emptyFilterMessage="Không có dữ liệu"
                        emptyMessage="Không có dữ liệu"
                        value={buildingValue}
                        filter
                        showClear
                        className="border-0 w-full"
                    />
                </IconField>
                <IconField className="search-item">
                    <InputText
                        value={orderCodeValue}
                        placeholder="Mã đơn hàng"
                        className="w-full border-0"
                        onChange={(e) => setOrderCodeValue(e.target.value)}
                    />
                </IconField>
                <IconField className="search-item">
                    <InputText
                        value={factoryCodeValue}
                        onChange={(e) => setFactoryCodeValue(e.target.value)}
                        placeholder="Lọc mã nhà máy"
                        className="w-full border-0"
                    />
                </IconField>
                <IconField className="search-item">
                    <MultiSelect
                        options={
                            Array.isArray(classificationData?.data?.items)
                                ? classificationData.data.items.map((item) => ({
                                      label: item.name,
                                      value: item.id,
                                  }))
                                : []
                        }
                        value={selectedClassification}
                        onChange={(e) => setSelectedClassification(e.value)}
                        placeholder="Lọc theo phân loại"
                        className="w-full border-0"
                        showClear
                    />
                </IconField>
                <IconField className="search-item">
                    <Dropdown
                        options={[
                            { label: "Nguyên vật liệu", value: "NVL" },
                            { label: "Gia công", value: "GC" },
                        ]}
                        placeholder="Lọc theo loại"
                        showClear
                        value={type}
                        onChange={(e) => setType(e.value)}
                    />
                </IconField>
                <IconField className="search-item">
                    <MultiSelect
                        options={[
                            { label: "Chưa đặt", value: "Chưa đặt" },
                            { label: "Đã đặt", value: "Đã đặt" },
                            { label: "Chưa về", value: "Chưa về" },
                            { label: "Đã về", value: "Đã về" },
                            { label: "SDTK", value: "SDTK" },
                        ]}
                        value={selectedStatus}
                        onChange={(e) => setSelectedStatus(e.value)}
                        placeholder="Lọc theo trạng thái"
                        className="w-full border-0"
                        showClear
                    />
                </IconField>
            </div>

            <div className="bg-white border-round-md shadow-1 p-3 h-full flex flex-column justify-content-between">
                <DataTable
                    value={materialData?.data?.items}
                    emptyMessage="Không có dữ liệu"
                    loading={loading}
                    size="small"
                    scrollHeight="70vh"
                    scrollable
                    dataKey="id"
                    rowClassName="custom-row-class"
                    onSelectionChange={handleSelectionChange}
                    selectionMode="checkbox"
                    selection={selectedProducts || []}
                >
                    <Column selectionMode="multiple"></Column>
                    <Column
                        header="STT"
                        body={(rowData, options) => (
                            <div className="text-center">
                                {first + options.rowIndex + 1}
                            </div>
                        )}
                        style={{ width: "1%", minWidth: "20px" }}
                        alignHeader={"center"}
                        align={"center"}
                    ></Column>
                    <Column
                        header="YCVT số BRAVO"
                        field="materialRequestNumber"
                        style={{ width: "5%", minWidth: "120px" }}
                    ></Column>
                    <Column
                        header="YCVT số PR"
                        field="materialRequestNumberPr"
                        style={{ width: "5%", minWidth: "120px" }}
                    ></Column>
                    <Column
                        header="Tên vật tư"
                        field="name"
                        style={{ width: "5%", minWidth: "150px" }}
                    ></Column>
                    <Column
                        header="Mã vật tư"
                        field="code"
                        style={{ width: "5%", minWidth: "100px" }}
                    ></Column>
                    <Column
                        header="Giá"
                        field="price"
                        style={{ width: "5%", minWidth: "100px" }}
                        body={(rowData) => (
                            <div>{formatQuantity(rowData.price)}</div>
                        )}
                    ></Column>
                    <Column
                        header="HH"
                        field="hh"
                        style={{ width: "5%", minWidth: "100px" }}
                    ></Column>
                    <Column
                        header="ĐVT"
                        field="unit"
                        style={{ width: "5%", minWidth: "100px" }}
                    ></Column>
                    <Column
                        header="Số lượng"
                        field="quantity"
                        style={{ width: "5%", minWidth: "100px" }}
                        body={(rowData) => (
                            <div>{formatQuantity(rowData?.quantity)}</div>
                        )}
                    ></Column>
                    <Column
                        header="Mã đơn hàng"
                        field="orderCode"
                        style={{ width: "5%", minWidth: "100px" }}
                        body={(rowData) => (
                            <div>{rowData?.Product?.orderCode}</div>
                        )}
                    ></Column>
                    <Column
                        header="Tên công trình"
                        field="buildingName"
                        style={{ width: "10%", minWidth: "150px" }}
                        body={(rowData) => (
                            <div>{rowData?.Product?.Building?.name}</div>
                        )}
                    ></Column>
                    <Column
                        header="Phân loại"
                        field="Classification"
                        style={{ width: "5%", minWidth: "100px" }}
                        body={(rowData) => (
                            <div>{rowData?.Classification?.name}</div>
                        )}
                    ></Column>
                    <Column
                        header="Tình trạng"
                        field="status"
                        style={{ width: "5%", minWidth: "100px" }}
                    ></Column>
                    <Column
                        header="Ngày về dự kiến"
                        field="expectedArrivalDate"
                        style={{ width: "5%", minWidth: "100px" }}
                        body={(rowData) => (
                            <div>
                                {formatDate(rowData?.expectedArrivalDate)}
                            </div>
                        )}
                    ></Column>
                    <Column
                        header="Mã nhà máy"
                        field="Product.factoryCode"
                        style={{ width: "5%", minWidth: "150px" }}
                    ></Column>
                    <Column
                        header="Loại"
                        field="type"
                        style={{ width: "5%", minWidth: "150px" }}
                        body={(rowData) => (
                            <div>
                                {rowData?.type === "NVL"
                                    ? "Nguyên vật liệu"
                                    : "Gia công"}
                            </div>
                        )}
                    ></Column>
                    <Column
                        header="Ghi chú"
                        field="description"
                        style={{ width: "6%", minWidth: "150px" }}
                    ></Column>
                    <Column field="action" body={actionBodyTemplate}></Column>
                </DataTable>
                <div className="card">
                    <Paginator
                        first={first}
                        rows={rows}
                        totalRecords={materialData?.data?.totalItems}
                        rowsPerPageOptions={[10, 20, 30, 100, 200, 500]}
                        onPageChange={onPageChange}
                    />
                </div>
            </div>
            <ModalAddMaterials
                visible={dialogAddVisible}
                onHide={() => {
                    setDialogAddVisible(false);
                    setRowData(null);
                }}
                toast={toast}
                rowData={rowData}
            />
            <ModelDelete
                visible={modalDelete}
                setVisible={setModalDelete}
                accept={acceptDelete}
                msg={
                    <div style={{ textAlign: "center" }}>
                        Bạn chắc chắn muốn xóa hạng mục này?
                        <br />
                        Các thông tin liên quan đến hạng mục này sẽ bị xóa.
                    </div>
                }
            />
            <ModalImportExcel
                visible={visibleImportExcel}
                onHide={() => setVisibleImportExcel(false)}
                type="material"
            />
        </div>
    );
}
